import jsPDF from 'jspdf';
import { sendEmailNotification, fetchEmailConfigFromFirestore, getLocalEmailConfig } from './emailService';
import { auth } from './firebase';
import { resolveStatus } from './statusResolver';
import { getLocalSiteSettings } from './siteSettingsService';

export interface InvoiceOrderData {
  productName?: string;
  id?: string;
  orderId?: string;
  invoiceNumber?: string;
  secureToken?: string;
  date?: string;
  createdAt?: string;
  customerName?: string;
  userName?: string;
  customerEmail?: string;
  userEmail?: string;
  customerPhone?: string;
  billingAddress?: string;
  paymentMethod?: string;
  gatewayName?: string;
  transactionId?: string;
  trxId?: string;
  status?: string;
  paymentStatus?: string;
  total?: number;
  subtotal?: number;
  discount?: number;
  taxAmount?: number;
  productDetails?: string;
  items?: Array<{
    title?: string;
    productDetails?: string;
    category?: string;
    format?: string;
    price?: number;
    amount?: number;
    quantity?: number;
  }>;
}

export interface InvoiceSettings {
  companyName?: string;
  companyLogo?: string;
  companyAddress?: string;
  supportEmail?: string;
  supportPhone?: string;
  supportTelegram?: string;
  websiteUrl?: string;
  taxIdNumber?: string;
  invoicePrefix?: string;
  currencySymbol?: string;
  colorTheme?: string;
  termsAndConditions?: string;
}


export const LOGO_BASE64 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKMAAAC0CAYAAAD4v5yjAAAACXBIWXMAABcRAAAXEQHKJvM/AAAgAElEQVR4nO19B3xUVfZ/ghiRkk5HUIr0XgSkpZAECAkEQggkJJmZTEJbFNuCKIqKiqCA9GRmUkGwra66u667bv255b/ruqvuWlbWXkBRIJny7r3vf8+5781MhgCZmTeTCZn3+TxjQvLmle8753vO+Z5zIyLC2wXb1q1yB753jIiQI9Wfrd/DrimrsY/Vme06vcW+S2+2P6+32P5ksNjf599/xPf3DWbbnw1m+wt6k3U3/3mpocoxMXeXfK37sWfz48Lxg39V4a1tbbIcmXtCvor/H4KwyCJ3Kq2yzeOgM3HwfVRaI9E1x2V57QlZXv2ULJfXy7KxhsnGaoZfy+tkec0x/u/8d+D3jNUS05tsnxgstlqDSVqsqzzVTf0o+JwwKMPbhZsKQllYQl1lQx8Oonv5frL8KAKLldUyWW9qZLrKRklvtkql1RIx1lJaVi9TDkoGX411lJZWE6I32ySdqVHiv8uMNRT/fjUHKbeanxvM1p3FB38Y4v65YVCGN9zcwcAtYS9uAZ8orbKfBetXVkuZvrKRcHBKpTWEcmvIVnNg8f9nRQfOSPk7PqG5D7wnZ29+0770/nfZ8kf+x1btOy1x98ycv8sBy8HrgOMY+d/BcTmQbTqTrUpXaRsKnyu7LHJ4a48bAFAFALhjbgXvLK1ynFHAQgGAHES0/Bh3v8dkturJUyRj7etkQspeaeDgW0ivuHwpISqLxnXMlGMi00ncVQvk+KiFrGd0nnT99WvJ2BmPSXNLfy6tfPwLwq0rgFPmvBKPy8FK8XNqJBu3lnuMh+VEz3MKb+1h83DJ+gprBgfEuwAObrmo4obBCsrGWoll//jvZMz0h0mPbnmkW0QK6xqRJMdEzJXjOsyX4zkQ469eKHNQ4tf4qzPx5zERaXK3iGSZ/y5L7JxDRkzYSuZv+D0xVNkot5Yyd+PMHZT869e6Smv5bAyawnyyXWzuD9lYZR3Eo97nVx+FQIS7Y5MVeB7ngEwu498vvO3P0uCht5GYyDQKwALLl3BNNt8XCfA5AXjhDv8ufjcb/46DGHY2oH85mVv2KimttjNubWXglMAtjbUEQcmt85sclEl4sh4vTXi7QjZ391dQI3fhwLvPWONogIjXYLYRXUUjB4gkr+GAWPbgB2TY2C1SdEQqi45MRdBxUDEOMnYx8F1mZ/D3AMyYDukclElsEHfz3OIiB+VBDwdlA4Wgp5y/CPzF4N9bny4xWQd6nnt4a8ubR2DAH3iOwWL/L7pkHg2DS+ZglMF1rjrwHZ2ScZjERS2gYMkSooRl8xGAze+KtYyOnMuBmcZGT3uY5D/2CV2DPNUh6ysaCKcMREkLndeZrfer6aCw627Dm/vDM1TZR/Io+RfAA8vqwCU3cpcMwQkEEQ6WqntJ6h2/knSNmCPcrNYg9HTjcHxuccH9J1y7iE7NspDiwz84+aQeovdqhU9a7P8rMTXmN3dd4S3EN3hYubnCGq6ul+O4y3vCWCPZ1zyFD1oCl1hWSyBpzbI3vUkHDt5AINCIvWo+8sFAgrA5UEI0Di9Bn+6FNNXwcwIvh8on4aXh58rw3E3235WaHZPhulypoDCfDMnNnVvBw+IgLOZW5QsRrdoxSuZfkReu3PU5j5B3SJzDMXCZzqAkiEB07lEL8fNjr5on+OSQW8mizf8ggk8SGfKT8BJB0pwDk+grbZWQlPe85vAWCptiJWRn9aRxGn94f0LeVUtFqsZkhQQ0tzbn2c1L6kli58UEXKQSnLQOCC8AZRaCMjoC+SQdPe0RacXOzwjyySqHrON8stTiICIPaj+jM9tuX/8KuwauGb1BGJStu7nzJ6WEZzHWSRSsCP9/4ZKPilTNvHW/k/r1NiAvBNcYbJfsC59M7LyITl9cI5UcOavwSSuWI6FGjhbf7Pg3f/EWKrejyUsZ3oK0ubunrSfkKB4Rb+SE/zuF8BOwIpwnQpTMMFUz5m6IkFlMhwwBwtZyyV6BcpHKJ1nfHsUkvfyXUlmdxKBWDsEX5EXhJYMXT2ey/QyCNM97E94CuXmoarhVmM/B945SWqNKqoaBa1u1/zSdlHZAirt6AYuOSBVJ6DYAwqauW+GTHYBPJrMhw+4gi7f8S+QnawWfhDwpBDgQpPHr37O2Wk6AexMGZQC3pi7ZNpQHKD8V1RMZxQx8RysB1Y3k4p+SXrErwCUzp+trbWD5BUrBbeGlirkqg42buZOsfOILkZ/kQRnyySqJKJ4BS4tbXw+XFjXfBDk/oQgazsRy97SjtMZhU6sn+soGUsajznJuLbJ+/Ddyw8D1SqpmXsjyQl93lU925Xyye5cldEbuUcKDMqyjQ5AGnsFZWjTb3tRZpBS8ieHSon9bE17I/19f0VjE3/rP0CVXieoJRJlgHfJ3fkpHT30Y6siM722GF/oOSuCTC5BP9uutJxnrfkuAP5bzYI3fF+ST8P9QWtSb7M/oK6yDm97TMChbuDVN1ZSaG6fzt/wNTNXUNU3VlFScY9NzaiWIOrGaEUqpmoDvWQqfzEARxo0jfyzl3v8fAvcFgjedW2mRB3eNeov9IV2ljKXFrXKYT152a1LCq2X99CZbTVmtxESqxgrKaQpvPHfLLH3t66RfL53ghSGcqgm4lVRewG6cT8Z2nE8nJu8lhU9+g3ySexJ03QaltMgB+anOYi9U73GYTzazASdU39RbT8jXcku4yVgtfS9yaXaid0vVwNt/46hNkLRmoIK50l1yi0GpeATQW/aMXkbnrHxW0luELlNncistHsfU0BtQHMCbzz3Q7K2vdwy7bo/0g1DVOD5Y+7SaqmmQDBaRqincdxrf+tiO82ibTdUEBZRQWpyPfHJA/3Ipc+OfJFCalwF/bFJalLjVtNYWm+Xr8FG021SQZwmv+vx47pJ/5amqge9BHZ1U+LzUMyaPwlvvbgUCtkdlCQ2iCvYoVyTrq8XCtgSkE0F4iZT8ZEwk6CdT6IgJ95G87R9BaZGBbhOlahYnnzzL7/3dxsNyZ3gWubkn2k9p0Z2n6CvO9Swx2Q5y9+FY7a6qqaPYd7Lwjr+S6weslYKmqonKciaZ4TPBAvOfE/49FeeQgTrHlh4r7upMdJtxnMt177LEkXBNFtbEoyHijwo8KJFPRmWj0jz+moV0yrwjpOjgd1RJi8nYaFYtqVK1D0tMDUube05X3ObuBnKhhGey3VJaZf9WpGocIlVTLVI1yx/9mIyc/ACJjpwbtFSNK12SxHonriJT5h+RMm/7E8176ENpyX3vkuTCFxx9exYTEDJcDpAAgjj+8nAAsJsWVEq5D7wvFez+2pa/4xPHXOOrZOCgDdhPA5YrGIohF5+cI/eOLyCpJS9LUBwQpUQoLXI+yT2SYhB+rau2j8eHdsVJ1TzU1hyEmWoJDxK0SgMU8kIQmE5daJYSOgkLEhTrgQ8qCy1Y9y459OYldVLJobPo0lYfA5EFpw71TF7DeWzJoR/IwCG3SAjIi1EFBOICObHzYpq96U2y9hnB17DZv45hc39pjYNmrPsN4ZwOqQdY4mBkA1SpGrxwAwf9iMD5NWl9MFmJ0ogmcdd9RH9U7gnP7ArgkyJKU019Wa08Ql9pfQXJM5TwlAYoEJJCFx40KvXpXuSWqgk4L3SW2Lj7ZWNv3imBztHZAlDZCE37qJTB6kbFeaAO8oqdn5DEzjlUtKZe+KKINEsKS9W/LK17llueI+exOoIKbjgWP67a6gB8GEqXvRMKBB8O2nUvatr6sPNT6pKqnSfgqRSP9S0H5a3gyeAZouuW25jrbtKFVy8n8gvaq6qtuWUk2NCuqK0Xb/kngS68rhHJLKgWApPFID64neRseVtyEx8gWLj1vmDXVTQAjWATUvdKUJLzBA5Y8ZiIdLl/vzIeINgoHqfZY9nE51iE2LeYW1zhEbJpMD1CglJaTLxWkapVXEyqZn/XaLEtEE+3jZQW3TP78DbpLNb1hir7KaU3mIoSnqK2fuILOm7GTimmQ4aSqgkGd1qE1gdlWT1LSPrq1yRjHUHrzK0XPIRmQajuYCnBjUEPdDclveT5gMHCTZy7T4KcqAq4i+8ClApXZpxTklFTHmzKlYPwYqqtD317wD35NdT6m5YW68V4Fn5/XjEccUnVZnsMxwqJzZNTgLSL72834YVQwsME7Hk2Y9kx0r3rEoxQg6G2dhcYAJcDK6A7co4oDVAIskuDRgEjBytwyLyHTzr4cWlznwNghIQzcMPLg1E9rgClmkXIuuOv0vUD1hCRysoMSlLf3VvcOOJOmrP1Xbg/wltUNBDu3YRUrZbYSkyNewtDTqrmkS/ELjyFF6K0C9XWnBcqjfHz1v+OXNfXQMEyQeQanFSNqzV0zLRHiCLlZyovBOvUEsAooOEPh3Gr/pUNWhfilIkS7mCEh5le/ksrAr2FIHdZXivuan51Vv4zJD4qE+8VBFkBB6Q7j+44j45P2i0V7PmqaWlRHc1S5fjKYLGWbw2FKRjuH15ec64HB95+Y43DgbzQrPDCGiJKeNveI0NHb5aE2joIJbwoj8hx8Aaa/eM3nU1OukvwwstYRgHGx7+0JV57MTCmwEtnFbIu78DoTgfg/NY9L8tzy35JoiPSWDCrTW4ZBtajWy6Zlf800ZsbmSpVg1QQ0Js1x1WpmjVFsU7B5ZNolpVWUBig6Z4vRF4osvvICwuf/IZNTNlL4q6e7yrhXRPEnFrCSpqqf0VS2z9bwgu1AeNv/QIj7gp9KDsq00E3biSXTCcF7F46pWo8KDPS+bf8HxGlRYVPVlqJU6pWaX2u2Gwb4sRIYF130wSortKWpTfb/40m24MXcvPN5hQ8R5QSXlDU1gDyBGxkwmoDmzK/Qio++D1Rqw0t5W8hA0b4PH7O4FluWlDhAP7YKsokZ2kRhlmlsuHj7pWWPfQhUh2jWlp0k6rpTPbt62tZNGAkIK7bHenAC3Um26vIC+uUgUmVMDCJk2/+1izY+IaSzOW8UJTwfJ1R08KbleW8WTAfB+qwyx856TMvDCkwmgQYecBlFWBsPa1mAtTrldIijICZnH6IFB04I/ik2Q6ZA+cUDJCqlZhsSz2x4/emWkNUW0NBvcZhd+eFpTU4MInlPvQBHT5+K6Q8glvCQ4VKEoPoEyaHqQoVX3lhKIJxapa51cHofo3xSs29V/wKmlzyEnGWFnGqmhVKi1SZgnFCnT2pjvvzE4gREasONvTlD/b1dU/jIE0xMIlbG9GF9y2dnHFIir8m0zUwKWi1VtDu5dE5K5+T9Bab2guCu5YgDIOxeUOgBog3DPqRlHXX30i5UjjQoVTNLomZl46PSw43zgAcbfUVkCqSi440TDVWOz4HpOvMNgegH3p3DdV2mrzqJ5JHF14QXLJQNUNQNDHlSXdVs6YuOQzGFj0PppYW+U5HTdku5e/6DJ4HlD8BlGAl5bI6SSoxWfU+WUj1D4qPWNPL6khDWR0OV8fxcfDgc7a+Q264YT0RvDAIJTyVF+J8wxQ2dPRmAukiTMpymhBoEIbBeDkrma1I1cQUDNCfQl5ZeTbcjTuIMnhrk7vHveym/mLJ4XOpHIhWyBXqxAHlsnrCZiytl2I7QglvbpClXXPYdX0MZP6638GF4oRZFDP4kaoJgzFwz2rkxPtJ8eHvqZoGMlQ50G3rzI13tchCqmF4ycHzYzkQzxhrMRBAUYPOdJ6OnLSNdImYzZzK5wC/bU5pV9cldMayY5Jbj7DfD7pNgXGhqU2AEXfFi8H5Xte3lKzgbhtHslQ0MACk0Ew2Fl3aQipZ89xHvovh4HsbD6BUUUo4CAYPvU2C5Gdip8VBuBhV2jWPjZu1C6cnrOY8BEbaBcslhxIYb86ps2qZZwxGNSexk5ioxiNusvzR/xEFTxRkapxHNuoqGya5G8Bm3TOPliuhIQrWLoE/NPAHMHj4HSD9xw8I9Bul9AHLQ4bfSXLufdtVrA9AqibkwcivGRY0mpX/tGZgBDcKMjdne28AgamO+Ovbs4gW7v0aFm1CDgnA5F7370VbT3ZSLGHkBUDkwEuHJci45SHgCkFBMnbGDu6aA2sR3ctO/XqVUHcZU7B5YUiCcfkJTcAI55vYOYf1v64c+nEY3O9A9xaBAYPAZtDQjTCslSn3UVor0oT3XcRdy5HGOvKG6p5BdZJieBkj5kCdrCcvhEGeyAu9lHZd+WD03zIqiiJ5WnaVnd9fadn2/1L+/6RXbH7AVeYASIg1pi2qQmkdpAehS9FYLf3gvqqDyyrWkmVKcABr4skFe76mPaJzKTYWaWzK1a41Raqk8MIvndJ3LerIVxYY/beMalAxp+C5xjVihKAoWhz4jk5daCFNVOYBAiXkhpc9+D4BTSisfyP0rnSPyzoqgQsPVH6Nal7FKk5K349TXhO05Ike+cIbR97FeeE7pCWS/1DY2zJnVME4c9kxK1qnigZFZS7KudCROWLi/aAOYqIDUlvRs2qZR0y6H0u2sChoaTWVDdXSKX2FaPzCDVoTS7k/B9cIVhHWu0vskkOFqFOrk3HWkWUQ2M5bL/KFWki7rmQwQgA3I/eYdmDMO45gVM/NqTKvV3rVb/8LGTz0dgJiZGytiMrSMPrOwh7ypdvehdVocX4SLIdsqCalTjByq7gFE5KVDRKY7pnLn5K04orqxXRT6sigXtabGqjSoxuwOvIVAUYltTMty9Lob57xYmB0uzZZCVrFmomb3iTDx92L/Tix6vhpDQwSnMOktP1EcMcGbI0trSIvO8HITfVvIXCBBRxBmzhw8AapJc3qlwdiNkZrcEET5uwmsDJpqPPCFoLRHkww3rSg0h5oMIrdprTn2hCU4E5BCQUZDuST/gKSG6XYyAy5b68SUlJxnkJ0ja66ynEK1T2wxnJpteNMaRWPbmpllv/YJ0BmSbzHjfb+4rNx1gsEQZm3viFB0tpZRw5hXng5MIJ7Wf7ISXt81ELS3DUHAIzyxOQ9cnDA6AFKpR8HVlsYOWkbhXVq/OaRop2XLrr7LZEIh955fk+NVVISt4qO2WV14ofwwfPW/QZ7Vfy78GxMrPbpsYrm7/gYrWEo5Qt9B4cAY972j2zxV2cGDYxjpj3CujXTpx04MLpAyV0pBjncUtLxSU84NDoPHpSdQEoI1FBp8NoQYbA4yt354vRF1RSjaB9NMvBDaMbvEbOMruBWFpce45Fb6wDIJmtZOgw+GK3gKsnw8ffalD5tnyV6voHRdR7wFfpxho3bInSrPgJSjarH3PwoDPtiaoqHe8vDEdxa7UAw8h9CNDVm+iM2vz4MzHBkOsvc+IZAPhTIgw1CJUJUhbZaWeRWASN/JiMnbyP+PBN/waheO+gUivadIr3iVpDYDr7ln4XuYK48eOht1FiLbSsEUoqcP74GlrF27XERZoMPHzZmM21uWoI3qB8741GIlpgu2EGKs/HKgVwHerdBi2msI5i2antgFG56cvpBKbicsfkdXDYYmJTiF3FMoU/ng0HMPLlvzxI7DoPlQYyxBsXR/43Qm2w/R2RC5aWGAmJlv9oiO2ayZds/lJQ8UlBBCEHYGmVWDMz8htTE4KEbGYy00+J8gg7GQCS9/QAj3GfIhEAkzCNiCpGx1zlImNLGrSp0CBQdPEM5H+URNeHPzP51BP+AP0M0A2kdMMODb9zoExhV2dfQUZsIcIugBCsqCEUVQS45fJZBgxAMXgJQRHeYK18bMV0eNn6LkvVvg2Dk15Vc/FM5JMDoOicQ/Eo+nZMCxp4xy+Wi/d/JAowUnuVXAMZ/QTQtwEj9AKO42FkrTpDVJ1o+Z8anGwIJWn58KCGq9dVZy0+Qvj2KMP2AUyuisqFAz4Db9O9rtEE3owEkcX4ENK0FxpRQAqMIquRFm/8hxUSkez/polkwEjj2VzCk6R+agBHzR2ls0aY3JbXEpzkITQoI6wQIC/Z8Q6cvrnY2hcV6LFQJvb4xERnydX1Kw2DUCIzoqjl4ig+c4YHMSu8DmUuCEQa7HxN90P6AEbVy3BLlP/YJgwmtWgQMTUBoElO6oCKxYtfndMq8Q6RH11zaRJPncVPCYAwAGFVA1hBYqN37St2lwMgfzqsuMPrIGZ2kNN+xav93DjiOFlUWtXYNTT2Qk8p7+CSZkLSHJF67GDV4MD32UmplFxgNYTBqCEZ01cdlOnradu+T4Jdx079UVqBCHePgobf7BEYI1/skrnKUHDnngIDCXzCigqgGM/9syf3/IWOmPwLj4cTsnpauiAXnxcHYr2cJ0VViQ1AYjFqAUTmvSXP3eX9eLQOj6E0YNuZu2esEqzsYK/wHowAilVfu/pLBqgexV82DQj0H4UKvLjxsGQNlGUX+c2q2xfv8Z1DACG46fqWj6OD3Djy4X2DECbFs2PgtBFIzYpSeD0n4K4MzslkrnraFGhjhGDNz6xtD0jICf+sRvcxRuPeUA6ya7wGMDSRFOLjpuj56MXTeR3HnFQFGkfT2/qEHAYzTs6vsIQvGntF5jsInTyMYfbeMLjD272dE9U+7B6MmDVnag3Fy+sHQ5IxagxEeRP++YTCGNBgzwmAMgzFUwJh+wCcwQnzRm8cXsOIYBLshD0Z0031Lw2AMYTCOm7XLFzBiibZ3QqGt5MhZCcQtIQ9GSKyGOWOIg3HmY75bxoRCe8nhUAcj1j4lGRaThLUEIX/p6xCBKwWMs0M0mnaB0fs0YJsBIyqK959x9IpdYY/zUVHcFIwGu8Fs1RCM/7W3Sz1j0/PiYNzZDiwjgPHA945ecSv9AqOzNbJHMfbhlPoPRpRP5dzzT8x/XiDMCJSesehFFlJghPvwlExHT91u97VA0sbAeMZvMCaoteleelxOWAPLiGBcvOUtBHmwwJhSEmrlQKvMMQML1FvDYGw5GIWb7mu0asQZFTD+U26Oy7af2rQA46jJD3jfvNc2wei/mw5AABMGY3sCozp8qmDvN47uXXPtYsV7Hx9AEzBqEsBcAWB8KgxG78DI5ILdXzu6d86xe86z8WaHIZUxEWk4NdVYB01ifmosWwuMmnDGbBy+BWkiX5YfvgCMT/kMRrek9zkJgsqQB+PK3V85undZYo/H4ZWLnDIyseZIlnN+oGtf1OT3QIALKzh1ipgGwzaJvw+gNcHIo2kEY2LnJTgv0+ud3xf4WzhGcvGLNhw34280fUymIydv89kywiCAooPf09CuTSt5xlX7vpUSuixydI6YKXeLTME2WFCgww7WDnb1e/i3rhHJuP4IiHD5zyg/f3pdbwOZsewYd892Ko7fxiyj2ol391uEXxf2+/i2J+EeE5lGc+55G5fC8KdhDgxGWb1Mho7eZPO1RaWNCCVcgIRxbFMyDrIxN++Qho3e3Dh42EY6+MZb5esHrJFvGLheHjx0ozxk2O3S8HH3NI6f/TidutBMOL9yZN3xV5r/6MeEXxvOB1eP6Q8wWgOM6nnDA4N7MXWhCdaEkVu+V8rTsizyrLynZPAOHIgOaO/VoiWkrI6DcdSPAwVGpQdmmG89MJqCER+CXYbVDsClQB8MDEDiN4CV8XOEfxfriTAZf3ZUhglqDH4XwAfXA/8mAKThEr+tAUZlLz8m7oU/O9xPrRrl0DKOCpBl9Ls7UAWjovTWxhI1ugY4QeM+dAu6HVf9XkxdVX/XNfBJ8yV+WxGMzuvzZ9eolz1IYPSxb9r1AQ7O9TQDY6jtrQnGUNpDHoyiO7BQs1bVUNzDYAyDMWT2MBjDYAyZPQzGMBhDZneC8e632CVVO+s4GDVIsofqHgZjCOzq9P+sO/7S7D1SwTj/R78PW8YwGAMNxkYE44Jb/+hotjCgiHkXbf4H87fKEcp7GIwhsKszZlL0L9ug7Ng8GOchpwyDMQzGwD4EpSflpgUVpFkVTRiMYTAG8yEY62U6ZMSdpNl7FAZjGIxBeQAwtLSWyfmP/o8kXJNFm13OLgzGMBgDuptd6+itfVpm42buJBed1hoGYxiMLb6JpsaWCw4UAII6CNQuMEt8Vt5xBywOftEJFwEEo975Unieo9tKYKqgxP1799/XaqWwMBj93KvsOBd89QmZwgDOy8mt4PdgYGlJxTkKKziMmLCV88RUdsl+nECBUZmyAWkliObdz5F/T6GHGfayozIOGYA1b9SfKdeLv2+s82dupgcYA6lnvHLBKM4DgDEz95hjQvKexpsWVNJp2YrotJl9enaVPCl1v234uHtIvx7FNCYyjUUrq9K35D5oCUa9qnzff5pCfjPV8DMrnOPULDPMR7RNSN5tHTvtEevYmx9tHDnxfjps7BZ51E0POeB7Timsk9L2W0FoO3vls2T5jo8lXK9PC3HtUZny+2OL9nZpP/4yg9ywe9elcsETX8K1tSMwmpWpZhUNrFePfNo5YobcLTK5iRz/wn0OtjHAjVbLfi26H1qDUbGIRQfPsP59jbjWTbfIFOY6xyQ8T0jAqzucs/v32I4RmSR3iZjNAbCE5j/2CfV3aRRnQ9YUHxqyrlbA2GWJvHLX5zC7PVBg1G61A4OHkNavN1mZjT1j2VFcxi2xc46zUanZvZNbY5eXC+5oCUY3YQZYIOo6r6bneNm9k9qQNUdO1f/MoUVDls+tqu5gfPyLwFnG3sIy2rUAo2hhdGgmk0dX9+Rp0jNmGY27yo/5PUEFo6v8iE1m3iz+47GLunmynFLykjatqqENxgxYtpVwd0hwwJIfIAIwFx8+S4v2f0u0cvnO6klmhW8LMLYiGDPW/Nr7JrlmwAjXnaJ7yW9FUUiDUawbmA6TGzTpPIMHmfvAe/LoqQ/DUsFMi5QEHAP7sXd+RhI7L6b+DAcIKhg5cFINr7Bufq833e7AaPA7lyXSBkxesfNTiLzosgff12StaLeHyyak7Ja6BcI6ag3GJhMl5vg9UQLBWPLyle2m3S2jFmkDiPbgRCEynDR3H0yDYFpoA5XFjmDYpxR/dSYNecuoBF5zVj7n0Gq8SZrxVdo+wNhbG8toRMv4GR67Z0weLdr3LbbRakIhQOgAABljSURBVJKwFaM52KipD128rBdKYNRsUSIRwGSs+ZXcDsCYhpMe/LdeKhg/lSEFA+4pqeA5CSdnabCgujNdcs+/SEyHDKZpVB0gMM5cdlyDMcoCjOmrX2NagdGnYaGBB2M2gnHg4A0YCfs1ds4djJ0W43EHDFhD9BZt5uWIz7BiBWHomE2S1xWEYIJR4bhTs8xWrwe5XxSM2lhGKDWOmvKg92OUg2UZBw76kQJGbSyjmnSGmvCCjf9HtOorwYfMrznz9jeIED6Ewejtefk8YL4tgzFBgFEePm4LAWumjfjApk7IpQMH38IBmebdavJBBuP07KrGMBhDAIxCxJolx3VcQHO1T/PIaWt+RZrtZwkdMMqTMw55v65z+wWjwhkHbQgIGKG2Chc9MW2fpFWaRyTnHcAfaf/ryog/K3EFGowTk/d4v/hP+wWjsIw33LBOWWtFYzDilDPUwJFVT57SLs2jLK6TXPQTsDzM7yR4oMCYsjcMRu/AqF0F5kI37RqQPqfgWUjzMC3SPK6l4X4gfRILaXMLDYXB2GbBqE1tulkwKp8xoH850Vts1G8gulvHE7J889I6/wUUYTCGBhiFaqeY6iv9U+1cDIzqDcU0zy1/lESaR4PIWpGXFe79hvSIBnnZAj+XhwuDsVXB6NQzJhQ6Sg77p2e8PBhT5GHj7yHloObRahKruLls8rxD/lnHdgdGH1ZVDQYY1cm1Rfu/s/u99MZFwOh2MZDmkTRL8yhKofwdH5OETtnN90SHweg6L4XajJsVipbR9QFsxeOfU9AN+hrtXg6McOGgPtFSzeN88E/JbOzMx3wXULQXMKqrqt70kLblQP6fVwUYrX6BUd3ztn8EbYwBA6M6zL5HzDK6au8pPGet1DxgaXPv/zeJ7TifhS3jJXZRvWKDhtwqxrx4Wb26hGW0a2IZ40W0Sxff/ZbdnwfREjetpnlmr3iaYHORFmke9Y0/KrMRE7cSn2T+7QGM6kKj+78lPWPyiS8LjTbbHWi2cctotv+siWUc6hsYnUri4hclfy62RWBU0jxQOYEKClRSNFHzCK2jnL3pbyQmIu3ikyPaMRjVe7Tw9r/4JjJRPJtn3zR/7l9zy+ioW3sc3aoEiB/ko2UUF5sij5hwnwTi1UBaRtfnpbJ5G35PNEvzOD8fJo3d0fyksfYOxkoh3uDBi2/c2hXssqID3zGYKKFQrU8hgKleC67ObJWA69044k7ZH41fXMdMtuyhD0Bh49MFewNGOM+hYzZLqObRqsdabQ/d8AcJeqzDYGxqFQEjK3Z+IiVeu8i3pjZXj70dVlU1VDloeT0uqfdn7qatO9eKpm60aCMn3e9ThOQOkCEj7iLGOs4FxA1lgQCjC/zzae629zRT8zh3fpOuv2EduOuWCyiuZDDi4CkRRY+ctE3yGSNRgBEUYuOKqrBM4Bpc39H2VERpFdkAYNRVNiLXm5JxqPmprF5e9Lg5j6PFgmFDusqGFucdvQGjGshMTN2rnZrHDQRpxp9LXsnLrlDVjroc3tpnZDZjaT31R3Kn0jmYBwSpNB03goC/Uov0AHfT0sLVRzEixTWZ5xp+5t0DuMSFDxuzmXKSihEvXlQLol6vLKOa5oleRlc9+Y1maR51Pg+UNvv11nPrmNEy6xggce1NCyrsrQJGfh+4keLRswQTz2DdbiomsfkuJlEMCJuRe0xag0awgawBzl9N8iKMVdZBeovdAauYgqtb9uAHBISsvn6Y+8VD6a57lxw6M++4pLdYqbJ66yWVPd66adU6zlrxtKRpmkeRl4FKqMXysitI6a3+O9zTooPf0bEzHkMO7W8DmyI3ZNmb/k7KFTzAeuAlJtuIiIitWzuUWhxvY6LaYoNAgPW/rlwTsSncAA5s7PAbMKCcLrzzr4RzDgZrHgvQXGjFvAajM81jpCLN4z8QVauAY1YOfk96JxSSFsnLroAeGDF81IZBnN7cSJNXvSj1TlhJu6qR86XmU7bwZe2dWEiKD/1ADdUOCrgrrZLeyT0hXxUBm7HafmCNwhvh69Qsk1+8sekJCOsVE5kmR0fOZWOmP0oKd38FrpsBGD1vinvfNH5+CyI2Nc2zYMPvtVPzqNaRn+fNS1ooL2vLYASXzH9WdpRxD0lhYSWpf78yxEHsVfM1wYLqxcYn7UaOD3gDvmiskvZHqJuhWkqHm8dPBpGa9+hHNP6ahZpOXMDkKH9YcEN6dFtKkwqel0preFjvdN02JxjhHPJ3fCxxq9ci0YIaxQ8bezfRNM2D8jIqr3LKyy5TbWiLYIQomb904K3gxct94H0ybMzdhFMsFhOZLkCoUW85erHIdLr4nn8Sd7xxMCY5wchNZBQnqe/CP8AvgHWBpGYgpnXB8YTrTmIDB20gi7f8CwUPRk6S4aYAYQbumnPfO/bYyAzqzY3Apq0HtE3zuKaXHbm8dWwLYCx/DV2wruI8XhsUOgCEhXu/oZPm7idxVy+gmLaJyva/J+gCg5EiDx27GfLZEEVjftFYQ/62lVNFFYhXCevouEPkG60SzrrZ9TlJ7LKY+CU2vcRDg4fK3bYcc1UGm5CyVyra/52IunkUu/55HjisfMarjjhnmkfLpi3VOsL0sl2fXn56WQAmSsC18MhTk4kScIx563/D1j4D870JHrvwydMUaAhYfvh39Xc1fd7qvemQTpfc+7akWEXhomscRhcOZTkSvllx4Ps4jtKTZbXIHamYfvWiBKN7oTtP85NTL5qfJNyEXnEr0HXDG7rk/n/T3okF3vWkOJu28igMBdWqacsdFPDSCCJ/kfsRuFk7Go03SYE54ERX2cBytvxLmpjyJFFBCEYnIDMr+Z7I8dMlYjablHFQ4YoNMLyfv+TSv4oscifhnwUOXdbRYtevUerUypxENnbGDpgljQcMxImKG7WIk+R54EZY985LWHxUJoPvvbXITjXPyme1VfOYRRls+SMnCYzpuyiPDRQYl5/wG4zqzt0w6xm9HO4vEyCcrykvbA6I8BLcMHCdpLc0UmhJgaoLpvnMthx3/Dk3WbGQ3Gy+hIDk7hpHGVfZ2I0j71IAuThwgFSGuAOfVL/35Riupi0lzaNZzRqHHbHR0x6WgrUokQuM/lvGJoBUZF9+p2ou9zw4EEFsAl5u5e4vKKjpnRF0jaMe8LZ1q9whwnNTSWTh4cb+3Hx+hnnHykYCBFdXeZ5CpAqmNpBvkSY3QGnamn/rHzWbzaOCESL/rDv/Kl1UOtVGwBiM5weGCyxi78SVFDwK8sSKBiKCFun9/J1nExUrGHkBGN3NZcnhxtlldbQRkr4ASIh0S2vsbELyXpj4ykTeKQAkVyMwwk2ANVxgkR5NFwYSS3iQfr30RF2SIyhg1GA+YzDvP9wHWOrjhoHrpYLdX2L6Du4b8PiyOnJWV+mYhAZQbsYqum+zt8odEZAm2+KyWgJAZOiyLWKFqfTy1yDyEmmflq6P0gp73NWZdNlDH4qmLa2WKVNSLeOTnmjeVQdojHLSqp8EJM2m6a5gATMkPGqenH6I6M2NrAyEMk4gSlbuZdOa5YktAOQ8Yy05Vy7ydhLIwSBhWrDnKzr25sck/qFMCFBDy3WrgcxkHr1pNn3CBUY5zfiLoIIxpeQlv2d6B/p+Q8CJuePBt0iLtvwTRTelVXbkiMAVuWFrLD5iTXfHV4s39Q+KjpwfZ6hyvL9WKG8kULJwTolWcvHdb9FBN95G0HV3mBc6N0tN88Qup6v2aTibx4RDRuWl2/4j8eNfWKEK6ID50LOM/GXExjVI//WOX0lT9K8QoHPIDysbmM5sc4Aip7Ta8bnu0A/TfAKiuqmm1HhYjtGbbBYIx8vrKbptncmKXIBHRSzN+KrUp3sRLicGSeFQcN1ONU/+CUWqpMWAelEeLNx7ivTolssuKAgEzE2/QEMJjEjPogQ3j4/KpJPnHZGKDp7B3LQiO5NKqySy7mn8/vVVBxv6uuPJ5w1Iphp+6yptC/QWO1rJ0hqJwoeCygdSQSVHfqBTsyxSwrXZFF0YcojWc93OkSu9imlJxVnq70JJuCtBTEnFedqvl47C8RMCCUaFo4ZMAKNUzjg9AyCy4ePvJXnb/0tA66gGuxwfElhDbqTs3IDdLbAjR/oNROcmuw4GGXNufu8yVju+X4tycTvRK6tiQY1zxWOfktE3bSfRHdIYkFk1umpF68hm5qGQk/ltHVXRrdkm9b+uzHaBzC5AYJwy/4jfw0K1uJdxHeejS+7fzyjNv+WPkK5hZfUUK3bgLcvrKMNkdqXtl4aqcyMBL4CbZnOJ/m7uBy6rkvtyV13F+SNTRLME3gyInqCXJnvTmwRGFHfFVFAr8UmFO4JKqHD3l5zrUv8A4g7GfmX2CxTgAXDT/F7Csr2cl2s4CN8rELpKtnAfgfaAzlGR6qEMrLSWUNHUZ/83v0fZ7nhxlvkCsilWUq3YGCyOqfzh/B+4ag5EfEP4CTLgk6XVdpaie4UIcWYSc15ckG8mcJuRU7ZBCUrJO/rorhUwGtAyltsDaRnBisMxlj96kvBr8H3+jx8vsirNi70qg42f/QSBLMoa7FfhL6TwhgQpW7XjW27Fb1PrzLm5AbKGF9vgw1w8QI7Um+wFHJgfKyen8kmU7hcdOkOnzK+QQCMp+GS2NgPdvQJkMoO3GhQruooG3wCpDhc9fJb17VHEAHgXBjAZHIxv+Q5GDAAaxN9zCzRo6EbqywgR/+4XpGoy8J4NGX4Hybn3HUzVKAp9YjDZsLrFvaKDU7YD+qNyzwsx0QobfDi8CfD/K/ecjtaZ7Q9y8tqA7YdmhU/yBwhv1PKHT5IRE7dhOQ2U38HOT8ZEpkPSnkKXGwp6vQSLkJNRuWDP11L3LksunOXol2UUIlfIzQG/Xf7wRwRaZTVdp6YFIIRsCPBCmLUJBY4yTsPKjzHUuSIvrJcVWmb7ua5GHoWmSI0pLlbaC/IW6c4njVXyIM4nny2vZ/yh4EQycN0UyC7wyczb/0yuH7AGU0FaSdovuyNoMkFTB2vxSe69OC2t0Kiray25799SbIfm84zguhdv/gfzBoxYP+dAB+sDOoDpS+qk+E5ZNBpf2MADET4jQVHhJ1y7iE5fVE1KjpxlioILeaFR4YXcwLyrr7AtVB98wAIUvzePN0RXaU3hb9Cba9HEA5/krpuTXjDxBouVJa16gUBiGqoL6k0JOCCjFqL7GTXlQbJi1+fAgbBkhY1Il0n9qBWY9NWvOZqrwAgBa7Kcqn/Fseb45XOboh9ZCDCMdYSmr/4VgZQRilyDkK9NcBM5c+BTWFI5f+enghdWO0S+0KLwwir7ae6SN6zfw66BZ4sgvFxtORQ2d+7A/78jB2U5v/lfi4uSCFwkd0sMLnrVvlMskHL35h+CCGoSu+TgZ+fv+ERpfVC6Fi8CSuByoja9u9lyoCD8c2XgWWIBpYsdS7jksjoiMg8//jsZjJWsZBbTIUOhL4G2hm4lvEEbJMh+QFUNFODuvJC7aUeJqfFgeY3cA5+n3Mq80NfN/e3RV3wfz63Abm7ubdi0bbYhnwRFEDzg3Ac+IMPGbpGgy8/VCBRY1yT4UZKcwF0iDB8t3PM1inJLRQM/WC6GDUvgqnjQA6KLgt1fkO5dll509rcY35HKUvUvS+ueg7p4g2p1Ge5AC0AbeRxm1nxGR9+0XYqBnKwapAT6RVTaf8Eb9U4ooKm6V5yNcYIXNkrQHaiIX39RYjo/Fp4fSAxnb329Y6jwQh83uQmfNFTZR/KH/IqztGi2KnySyWVHKU4V69/XqJQWAyeFxz3KnbRDHi2XzlhSR3i0jK20cE4wrg00naLwbyM3jtp0maAiC48HavX01b/G40AAAH00sIO1gWRxcvFL2FPjzC4EwyWrJbxrFkJ2g0CWQwSaghdCVU3JF77HrzVLfYKhFJxoszmrOEp+0mTLBDLcpLSo8Em9qQFKYFD/VZqEAi9Vc1UYkhisCTMjt54se+gDadW+b1nh7q8JTCW7/oa1tEXRbRQuLydDFWrUTQ+RrLv+Hyl4/Av7yl1f2DNvfUOCVlAARcBfNuVcnH3rEal05MRtJO+RkwovlFDe5eSF1Y7vOC+83ZkvbCu80NcN0kAq5wAyzC9+IyRNhSrIQeDmAK+Cm1Ww92s6fs4TJLbjPCcIAsonlQcHCiTsD+E8tmd0HoM0DtKHDuktz/ehJcpCS8SDA5Z4bY6UeO1iWFKYYTUlKC55ETbgwwt2/YA1EmQxgKOKEl4DVXtROC8EHl9prJV7w3Np9XxhsLcmqaDD53vrTLaKshqJKDksLC2iVI27kZyt75Ihw++UmhD8gFsTATroFxGdc/gieD3rW32B4BjO41zj/XG8/Uz4CiCEbsmkwuclQ5VNlPDMVqoHjWEtZcjdTbbfcmCi8jrU8oVB3jxKi1UNE7n7fh1uUlmdKlVrpJCr5JEny1j9K6lfz5Lg8Ek3YAY6stUMhG68EKw6ZAoK950W0i4L8MIGibtmlRd+VFJlX6Y+CQRhSOYLg7x5ugW9xZ5rMDs+XPu0W2kR+CRI1SrO05tzamHAAJJ/dyvWbvcm0q5kFFbkPvg+BCdiUgdQH7OdKPnDs9wa3lNQ82UXuNdYQTtxov245JZu7qXFghq5C4/ythhrHGcVlbngk0KqJsN6MzBEClsfWlmq1qrW0DkuZg67rk8pmf+jP2BqBjIBqrQL5m+CZ9FVWo/ynw2A+9vueKGvWxM+WS335ze0DmqkONQUBgwAn4TxHNydL9r8FoX1SJpI1dqIW/UPhMIbwAJN3bsupTPzniI6U4Mi7WoUJbw6iqkbvcX2pxJT4wy4n+2cF/q4edy0UrNjOncvb8DNNXpI1aCDca7h51KfxFUISlFKCw2JvuYgvIS0C7wGVrc4tVG8yec6i71YfbFDt47cRjaP0mIHTryLSi32T/Fm85uuV1ofVvPviw99T2/KrCRQUQmF1gftrSGknRRp1zCQdr1NsYyJgg+FFx7Hl9PKX9YdxhNyDN63tlrCC9VNEG0lP1nLonUm+3ZOxhudUrVKN6nao/+joyY/QGA4aWtI1bQHYbabtKuEpK9+TQIOCFkG6MJTpV2okDJZXzBU226E+xTmhQHdZA+pmnWQ3mx9xilVq7QSnHBVR5FPZt35V3L99WsVPhkkqZrGIFSlXYmdF5HpObVSScU5isM+zdYm0i7OC/9ZbBZ9yc4GqDAvDMLmwSeNldYkHnn/fY1QIyOf5O4bi/3cStDkVS9IveLygydV83d3n1/ZIQ2zBit2KdKuqqbSLs4LT/Moeb3xsHw13IswL2ylzd0NQXO4wWQ18of1VVOpml1I1fafppPSDpC4qOBJ1Xyzhup4wCQ2aPAtJHvTP1DaBXIzEN6qJTzOC6USk+1giUnu7nkvwlsrbu7WQF8hx+vM1sdLaySbokghugqYpib4ZO6DHyjddikUa80hwieFtRbqod4JBSRVj9Iupsw8R2sPPFGkbmy/5sAcD9cL1y2mNIRdckhtTUBZbRvOedVPITcJ5F5JBQmpGkzz3/CH4EnVLgVCpTkNrXWnhZANkJpKuxrcpV0f6iptS9yvN1zCC+FN9pCq6c22+Xx/WwyoJE1Ki9B9N2v5Cal7t6VBk6p58kKxJEkqGzmpqbRLL9RLBFo2oISng2rUYbkzXBOmanLDLrnNbFBvdZsVdDV3bT/ipP+04JMgVTtPDFWKVG3PVxSSx5yrufSKAXTdWMJrIu36i9t0BpB22XAIO/JEk7XeWN3YH64jzAvb+ObuugtqzvXglvEA9HWAMgj6PLD1oZYoUrV3yJDhd6BULdbZi6Lt8hPwVUi7lpM5Bc9L0JiGPJBH/yD5h2wANnOZbX82hkt4V+Ym+JUYFV1mso+FeTAoLPWQqhnrKfYL9xVSNefqUL5oGYU7XqisOyjyhbEd59OJKfukwidPUXWBT+SFVaKEV1pl/5wHYDpVYR1O1Vyhm6ebKzE1LNZb7O81naqmSNWOnKU3L6kn3ILhaBbgdirPu6QbVxTe6u/FdkB3LINaHQYYLH3gPepahAlKeDZcVZRHzjb+UjxWZJFj4dzcFfHh7QreEJS5rqlqnKPdyYOEM4plQqmaMlVNXrX/WwpLecDQAe66IXGObQM409tz/k3HTAQfdPoBgGFsXK+4lWRC6l4JFmgXkn+XtEtUjqArz/qirtY2VD037MKLiAi75Pa0ubtAXaXch/M0s7FWwqWIgU9ipaNawskKsAxtzr1vE1hNauiYzQTcOPS0AAihbiyGpGbRXvErJZC0TUo/IC245Y84RBMsIYAQEtY65IVUSdXY3oZR1e7nE+aF7XqTI937gY3Vjkk6k+114I84tcxsoxxADlj+GFZPAGtZVi+zkiPnaMHjX5C8hz6Uc7f9R8598H05/7FPadGBMzB6D1w9BiYg8wdOCHVz4KdK49kXnA6sgzUb4TPDvDC8NdkuaH0wW+fqKm2/Aa0kAKisFi2bABZ3sQYecADoYL0caO4Xy49RmOCKJTsBwEZirCa4fIbSaPahvspxq1PaFU7VhLdLbZ6zBUvNjsk84n2SA+lkWS2ROTDRbQP4SqskMS9H2bnFw2XdICCB38NVIsz2U/zvT3BgZxVZTop18jwS8+EtvF1y83SdOD66snEaBDvcdR/Tmx1vGiy2bz1G5v3Av75jMNuf51HyVl2VNU2NjsUGlEBu6yNCArb9fxb3Ax6XXsSjAAAAAElFTkSuQmCC";



const DEFAULT_SETTINGS: InvoiceSettings = {
  companyName: 'RH EDITOGRAPHY',
  companyLogo: '/assets/logo.svg',
  companyAddress: '4141 Hacienda Drive, Suite 100, Pleasanton, CA 94588, USA',
  supportEmail: 'support@rheditography.net',
  supportPhone: '+1 (800) 555-RH-EDIT',
  supportTelegram: '@rheditography',
  websiteUrl: 'https://rheditography.net',
  taxIdNumber: '',
  invoicePrefix: 'INV-2026',
  currencySymbol: '$',
  colorTheme: '#0284c7',
  termsAndConditions: 'This is a computer-generated invoice, no signature is required.'
};

/**
 * Generate a client-side jsPDF Document for an order
 */
export function generateClientPdfDoc(order: InvoiceOrderData, customSettings?: InvoiceSettings): jsPDF {
  const settings = { ...DEFAULT_SETTINGS, ...customSettings };
  const doc = new jsPDF({ unit: 'pt', format: 'a4' });

  const rawId = String(order.id || order.orderId || 'RH-1001').replace(/^#/, '').trim();
  const invNum = order.invoiceNumber || `${settings.invoicePrefix}-${rawId}`;
  const invDate = order.date || order.createdAt || new Date().toLocaleDateString('en-US');
  const custName = order.customerName || order.userName || 'Valued Customer';
  const custEmail = order.customerEmail || order.userEmail || 'customer@example.com';
  const paymentMethod = order.paymentMethod || order.gatewayName || 'Online Payment';
  const trxId = order.transactionId || order.trxId || `TXN-${rawId}`;
  const status = String(order.status || order.paymentStatus || 'Paid').toUpperCase();
  const currency = settings.currencySymbol || '$';

  const items: Array<any> = Array.isArray(order.items) && order.items.length > 0
      ? order.items
      : [{
          title: order.productName || order.productDetails || 'RH Editography Digital Template',
          format: 'PSD / AI Vector',
          price: Number(order.total) || 15.00,
          amount: Number(order.total) || 15.00,
          quantity: 1
        }];

  const total = Number(order.total) || items.reduce((sum, item) => sum + (Number(item.price || item.amount || 0) * (item.quantity || 1)), 0);
  
  
  if (items.length === 1 && (Number(items[0].price) === 0 || !items[0].price)) {
    items[0].price = total;
    items[0].amount = total;
  }





  // 1. Top Header Banner
  doc.setFillColor(15, 23, 42); // #0f172a
  doc.rect(0, 0, 595, 110, 'F');
  
  try {
    // Logo position and size (Real Aspect Ratio: 163x180 => W: 43.5, H: 48)
    doc.addImage(LOGO_BASE64, 'PNG', 45, 30, 43.5, 48); 
  } catch(e) {}
  
  // Left side - Company Info
  doc.setTextColor(255, 255, 255);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(18);
  
  // Align company name perfectly
  doc.text(String(settings.companyName || 'RH EDITOGRAPHY').toUpperCase(), 100, 42);
  
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(8);
  doc.setTextColor(148, 163, 184); // #94a3b8
  
  const addressLines = settings.companyAddress ? settings.companyAddress.split('\n') : [];
  
  let currentY = 54;
  addressLines.forEach(line => {
    doc.text(line, 100, currentY);
    currentY += 10;
  });
  doc.text(`Email: ${settings.supportEmail}`, 100, currentY);
  currentY += 10;
  doc.text(`Web: ${settings.websiteUrl}`, 100, currentY);
  
  // Right side - INVOICE
  doc.setTextColor(2, 132, 199); // #0284c7
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(22);
  doc.text('INVOICE', 545, 44, { align: 'right' }); 

  doc.setTextColor(255, 255, 255);
  doc.setFontSize(10);
  doc.text(invNum, 545, 60, { align: 'right' });

  doc.setTextColor(56, 189, 248);
  doc.setFontSize(9);
  doc.text(`Ref ID: #${rawId}`, 545, 74, { align: 'right' });

  // 2. Status Watermark Strip
  let y = 115;
  doc.setFillColor(248, 250, 252);
  doc.rect(36, y, 523, 26, 'F');

  const statusDoc = resolveStatus(String(order.status || ''), String(order.paymentStatus || ''), (settings as any).enableTax);
  const statusColor = statusDoc.rgbColor;

  doc.setFillColor(statusColor[0], statusColor[1], statusColor[2]);
  doc.rect(36, y, 5, 26, 'F');

  doc.setTextColor(15, 23, 42);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(9);
  doc.text('STATUS VERIFICATION:', 48, y + 17);

  doc.setTextColor(statusColor[0], statusColor[1], statusColor[2]);
  const statusText = statusDoc.documentType.toUpperCase();
  doc.text(statusText, 170, y + 17);

  try {
    doc.addImage('', 'PNG', 425, y + 2, 120, 22); // Placed right aligned inside the status strip
  } catch(e) {}

  // 3. Billing Info
  y += 45;
  doc.setTextColor(2, 132, 199);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(10);
  doc.text('BILLED TO:', 36, y);
  doc.text('INVOICE DETAILS:', 320, y);

  y += 16;
  doc.setTextColor(15, 23, 42);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(9.5);
  doc.text(custName, 36, y);

  doc.setFont('helvetica', 'normal');
  doc.setTextColor(51, 65, 85);
  doc.setFontSize(9);
  doc.text(`Invoice Date: ${invDate}`, 320, y);

  y += 14;
  doc.text(`Email: ${custEmail}`, 36, y);
  doc.text(`Payment Gateway: ${paymentMethod}`, 320, y);

  y += 14;
  doc.text(`Transaction ID: ${trxId}`, 36, y);
  doc.text(`Status: ${status}`, 320, y);

  // 4. Table Header
  y += 30;
  doc.setFillColor(30, 41, 59); // #1e293b
  doc.rect(36, y, 523, 22, 'F');

  doc.setTextColor(255, 255, 255);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(8.5);
  doc.text('#', 44, y + 14);
  doc.text('Item Description & Digital Goods', 70, y + 14);
  doc.text('Format', 340, y + 14);
  doc.text('Qty', 420, y + 14, { align: 'center' });
  doc.text('Total', 545, y + 14, { align: 'right' });

  // Items List
  y += 22;
  items.forEach((item, index) => {
    const itemTitle = item.product?.title || item.product?.name || item.name || item.title || item.productDetails || 'Digital Template';
    const itemFormat = item.selectedFormat || item.product?.format || item.format || 'PSD / Vector';
    const itemQty = item.quantity || 1;
    const itemPrice = Number(item.price || item.product?.price || item.amount || 0);
    const itemTotal = itemPrice * itemQty;

    doc.setFillColor(index % 2 === 0 ? 255 : 248, index % 2 === 0 ? 255 : 250, index % 2 === 0 ? 255 : 252);
    doc.rect(36, y, 523, 22, 'F');

    doc.setTextColor(15, 23, 42);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8.5);

    doc.text(String(index + 1), 44, y + 14);
    doc.text(itemTitle.length > 45 ? itemTitle.slice(0, 42) + '...' : itemTitle, 70, y + 14);
    doc.text(itemFormat, 340, y + 14);
    doc.text(String(itemQty), 420, y + 14, { align: 'center' });
    doc.text(`${currency}${itemTotal.toFixed(2)}`, 545, y + 14, { align: 'right' });

    y += 22;
  });

  // Table Border Line
  doc.setDrawColor(226, 232, 240);
  doc.line(36, y, 559, y);

  // 5. Total Block
  y += 20;
  doc.setFillColor(241, 245, 249);
  doc.rect(340, y, 219, 48, 'F');

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(10);
  doc.setTextColor(15, 23, 42);
  doc.text('TOTAL AMOUNT:', 355, y + 28);

  doc.setFontSize(14);
  doc.setTextColor(2, 132, 199);
  doc.text(`${currency}${total.toFixed(2)}`, 545, y + 28, { align: 'right' });

  // 6. Footer Notes
  const pageHeight = doc.internal.pageSize.getHeight();
  let footerY = pageHeight - 60; // place near the bottom

  doc.setDrawColor(226, 232, 240);
  doc.line(36, footerY, 559, footerY);

  footerY += 16;
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(8.5);
  doc.setTextColor(15, 23, 42);
  doc.text('TERMS & CONDITIONS:', 297, footerY, { align: 'center', maxWidth: 523 });

  footerY += 12;
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(7.5);
  doc.setTextColor(100, 116, 139);
  doc.text(settings.termsAndConditions || 'All digital items are non-refundable once downloaded. Thank you for choosing RH Editography!', 297, footerY, { align: 'center', maxWidth: 523 });

  return doc;
}

/**
 * Robust Client PDF Downloader
 */
export async function downloadInvoicePdf(order: InvoiceOrderData, customSettings?: InvoiceSettings): Promise<void> {
  const rawId = String(order.id || order.orderId || 'RH-1001').replace(/^#/, '').trim();
  const encodedId = encodeURIComponent(rawId);
  const fileName = `Invoice_${order.invoiceNumber || rawId}.pdf`;

  try {
    // 1. Try server endpoint
    const orderStatus = encodeURIComponent(order.status || order.paymentStatus || 'Pending');
    const response = await fetch(`/api/invoices/${encodedId}/pdf?status=${orderStatus}`);
    const contentType = response.headers.get('content-type') || '';

    if (response.ok && contentType.toLowerCase().includes('application/pdf')) {
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
      return;
    }
  } catch (err) {
    console.warn('[Server PDF Download Notice]: Falling back to client-side jsPDF generator.', err);
  }

  // 2. Fallback to Client jsPDF Generator
  const clientDoc = generateClientPdfDoc(order, customSettings);
  clientDoc.save(fileName);
}

/**
 * Open a clean printable HTML Invoice window
 */
export function printInvoiceHtml(order: InvoiceOrderData, customSettings?: InvoiceSettings): void {
  const settings = { ...DEFAULT_SETTINGS, ...customSettings };
  const rawId = String(order.id || order.orderId || 'RH-1001').replace(/^#/, '').trim();
  const invNum = order.invoiceNumber || `${settings.invoicePrefix}-${rawId}`;
  const invDate = order.date || order.createdAt || new Date().toLocaleDateString('en-US');
  const custName = order.customerName || order.userName || 'Valued Customer';
  const custEmail = order.customerEmail || order.userEmail || 'customer@example.com';
  const paymentMethod = order.paymentMethod || order.gatewayName || 'Online Payment';
  const trxId = order.transactionId || order.trxId || `TXN-${rawId}`;
  const status = String(order.status || order.paymentStatus || 'Paid').toUpperCase();
  const currency = settings.currencySymbol || '$';

  const items: Array<any> = Array.isArray(order.items) && order.items.length > 0
      ? order.items
      : [{
          title: order.productName || order.productDetails || 'RH Editography Digital Template',
          format: 'PSD / AI Vector',
          price: Number(order.total) || 15.00,
          amount: Number(order.total) || 15.00,
          quantity: 1
        }];

  const total = Number(order.total) || items.reduce((sum, item) => sum + (Number(item.price || item.amount || 0) * (item.quantity || 1)), 0);

  const statusDoc = resolveStatus(String(order.status || ''), String(order.paymentStatus || ''), (settings as any).enableTax);
  const statusText = statusDoc.documentType.toUpperCase();
  const isApproved = statusDoc.isPaid;
  const isFailed = statusDoc.isCancelled || statusDoc.isRejected;


  const siteSettings = getLocalSiteSettings();
  const brandFallback = siteSettings.siteLogoEmailUrl || siteSettings.siteLogoHeaderUrl || LOGO_BASE64;
  const chosenLogo = (settings.companyLogo && !settings.companyLogo.includes('unsplash.com'))
    ? settings.companyLogo
    : brandFallback;
  const effectiveLogo = (chosenLogo && chosenLogo.startsWith('/') && typeof window !== 'undefined')
    ? `${window.location.origin}${chosenLogo}`
    : chosenLogo;

  const printWindow = window.open('', '_blank', 'width=900,height=800');
  if (!printWindow) return;

  const html = `
    <!DOCTYPE html>
    <html>
    <head>
      <title>${statusDoc.documentType} ${invNum} - RH Editography</title>
      <style>
        body { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif; margin: 0; padding: 20px; background: #0f172a; color: #f8fafc; }
        .invoice-card { max-width: 800px; margin: 0 auto; background: #1e293b; border-radius: 12px; border: 1px solid #334155; padding: 32px; box-shadow: 0 10px 25px rgba(0,0,0,0.5); }
        .header { display: flex; justify-content: space-between; align-items: flex-start; border-bottom: 2px solid #0284c7; padding-bottom: 20px; margin-bottom: 24px; }
        .brand { font-size: 24px; font-weight: 800; color: #38bdf8; letter-spacing: -0.5px; }
        .subbrand { font-size: 11px; color: #94a3b8; margin-top: 4px; }
        .inv-title { text-align: right; }
        .inv-title h1 { margin: 0; font-size: 28px; color: #0284c7; }
        .inv-title p { margin: 4px 0 0; color: #cbd5e1; font-weight: 600; }
        .details-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin-bottom: 24px; }
        .section-title { font-size: 12px; font-weight: 700; color: #38bdf8; text-transform: uppercase; margin-bottom: 8px; }
        .detail-item { font-size: 13px; color: #cbd5e1; margin-bottom: 4px; }
        table { width: 100%; border-collapse: collapse; margin: 24px 0; }
        th { background: #0f172a; color: #38bdf8; text-align: left; padding: 12px; font-size: 12px; text-transform: uppercase; }
        td { padding: 12px; border-bottom: 1px solid #334155; font-size: 13px; color: #e2e8f0; }
        .total-box { background: #0f172a; padding: 16px; border-radius: 8px; text-align: right; margin-top: 20px; border: 1px solid #0284c7; }
        .total-label { font-size: 12px; color: #94a3b8; }
        .total-val { font-size: 24px; font-weight: 800; color: #38bdf8; margin-top: 4px; }
        .btn-bar { margin-top: 24px; text-align: center; }
        .print-btn { background: #0284c7; color: #ffffff; border: none; padding: 12px 24px; border-radius: 8px; font-size: 14px; font-weight: 700; cursor: pointer; margin-right: 12px; }
        @media print {
          body { background: #ffffff; color: #000000; padding: 0; }
          .invoice-card { border: none; box-shadow: none; padding: 0; }
          .btn-bar { display: none; }
          th { background: #f1f5f9 !important; color: #000000 !important; }
          td { border-bottom: 1px solid #e2e8f0 !important; color: #000000 !important; }
          .brand { color: #000000 !important; }
          .inv-title h1 { color: #000000 !important; }
          .total-box { background: #f8fafc !important; border: 1px solid #cbd5e1 !important; }
          .total-val { color: #000000 !important; }
        }
      </style>
    </head>
    <body>
      <div class="invoice-card">
        <div class="header">
          <div style="display: flex; gap: 16px; align-items: flex-start;">
            ${effectiveLogo ? `<img src="${effectiveLogo}" alt="Logo" style="max-height: 48px; max-width: 160px; object-fit: contain; display: block;" onerror="if(this.src !== '${LOGO_BASE64}') { this.src='${LOGO_BASE64}'; }" />` : ''}
            <div>
              <div class="brand">${settings.companyName}</div>
              <div class="subbrand" style="margin-top: 4px;">
                ${settings.companyAddress?.split('\n').join('<br/>')}
                <br/>
                Email: ${settings.supportEmail}
              </div>
            </div>
          </div>
          <div class="inv-title" style="text-align: right;">
            <h1>${statusDoc.documentType.toUpperCase()}</h1>
            <p>${invNum}</p>
            <div class="subbrand">Order Ref: #${rawId}</div>
            <div class="subbrand" style="margin-top:4px; font-weight:bold; color: ${isApproved ? '#10b981' : (isFailed ? '#ef4444' : '#f59e0b')};">
              STATUS: ${statusText}
            </div>
            <div style="margin-top: 12px; text-align: right;">
              <!-- Barcode removed for offline reliability -->
            </div>
          </div>
        </div>

        

        <div class="details-grid">
          <div>
            <div class="section-title">Billed To</div>
            <div class="detail-item"><strong>${custName}</strong></div>
            <div class="detail-item">${custEmail}</div>
            <div class="detail-item">Payment Gateway: ${paymentMethod}</div>
          </div>
          <div>
            <div class="section-title">Invoice Meta</div>
            <div class="detail-item">Date: ${invDate}</div>
            <div class="detail-item">Transaction Ref: ${trxId}</div>
            <div class="detail-item">Status: <strong>${status}</strong></div>
          </div>
        </div>

        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Description</th>
              <th>Format</th>
              <th>Qty</th>
              <th style="text-align: right;">Total</th>
            </tr>
          </thead>
          <tbody>
            ${items.map((it, idx) => `
              <tr>
                <td>${idx + 1}</td>
                <td>${it.product?.title || it.product?.name || it.name || it.title || it.productDetails || 'Digital Package'}</td>
                <td>${it.selectedFormat || it.product?.format || it.format || 'PSD / Vector'}</td>
                <td>${it.quantity || 1}</td>
                <td style="text-align: right;">${currency}${(Number(it.price || it.product?.price || it.amount || 0) * (it.quantity || 1)).toFixed(2)}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>

        <div class="total-box" style="background: #f1f5f9; color: #0f172a;">
          <div class="total-label" style="color: #0f172a; font-weight: bold;">TOTAL AMOUNT:</div>
          <div class="total-val" style="color: #0284c7;">${currency}${total.toFixed(2)}</div>
        </div>
        
        <div style="margin-top: 60px; text-align: center; color: #94a3b8; font-size: 11px;">
          <div style="font-weight: bold; margin-bottom: 4px;">TERMS & CONDITIONS:</div>
          <div>${settings.termsAndConditions || 'All digital items are non-refundable once downloaded. Thank you for choosing RH Editography!'}</div>
        </div>

        <div class="btn-bar">
          <button class="print-btn" onclick="window.print()">🖨️ Print / Save as PDF</button>
        </div>
      </div>
    </body>
    </html>
  `;

  printWindow.document.write(html);
  printWindow.document.close();
}

/**
 * Universal Resend Invoice Email Handler
 */
export async function resendInvoiceEmail(
  order: InvoiceOrderData,
  recipientEmail?: string,
  messageNote?: string,
  customSettings?: InvoiceSettings
): Promise<{ success: boolean; message: string }> {
  const rawId = String(order.id || order.orderId || 'RH-1001').replace(/^#/, '').trim();
  const targetEmail = (recipientEmail || order.customerEmail || order.userEmail || 'customer@rheditography.net').trim();

  // 1. Try server POST endpoint with fast timeout and truthful response
  try {
    let token = '';
    try {
      if (auth && auth.currentUser) {
        token = await auth.currentUser.getIdToken();
      }
    } catch(e) { console.warn("Failed to get auth token", e); }

    // Use local email config or fast bounded fetch (1500ms max)
    let emailConfig: any = getLocalEmailConfig();
    try {
      const configPromise = fetchEmailConfigFromFirestore();
      const timeoutPromise = new Promise<any>((_, reject) => setTimeout(() => reject('timeout'), 1500));
      const latestConfig = await Promise.race([configPromise, timeoutPromise]);
      if (latestConfig) emailConfig = latestConfig;
    } catch (e) {
      // Use getLocalEmailConfig fallback
    }

    const response = await fetch(`/api/invoices/${encodeURIComponent(rawId)}/resend`, {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'X-Admin-Access': 'true',
        'X-RH-Admin': 'true',
        ...(token ? { 'Authorization': `Bearer ${token}` } : {})
      },
      signal: AbortSignal.timeout(10000),
      body: JSON.stringify({
        email: targetEmail,
        customMessage: messageNote,
        orderData: { ...order, id: rawId },
        customSettings,
        config: emailConfig
      })
    });

    const responseType = response.headers.get('content-type') || '';
    const rawText = await response.text();

    if (responseType.includes('application/json') || rawText.trim().startsWith('{')) {
      const data = JSON.parse(rawText);
      if (data.success) {
        return { success: true, message: data.message || `Invoice PDF successfully sent to ${targetEmail}!` };
      }
      return { success: false, message: data.message || 'Server was unable to dispatch invoice PDF email.' };
    }
  } catch (err: any) {
    console.warn('[Server Invoice Resend Notice]: Network error during primary resend, checking fallback:', err?.message || err);
  }

  // 2. Safe Fallback to sendEmailNotification with branded HTML (only if network to primary endpoint failed)
  try {
    const settings = { ...DEFAULT_SETTINGS, ...customSettings };
    const invNum = order.invoiceNumber || `${settings.invoicePrefix}-${rawId}`;
    const total = Number(order.total) || 15.00;
    const currency = settings.currencySymbol || '$';
    
    const statusDoc = resolveStatus(String(order.status || ''), String(order.paymentStatus || ''), (settings as any).enableTax);

    const invoiceHtml = `
      <div style="font-family: Arial, sans-serif; background: #0f172a; color: #ffffff; padding: 24px; border-radius: 12px; border: 1px solid #1e293b;">
        ${settings.companyLogo ? `<img src="${settings.companyLogo}" alt="Logo" style="max-height: 48px; margin-bottom: 12px;" onerror="this.style.display='none'" />` : ''}
        <h2 style="color: #38bdf8; margin-top: 0;">${settings.companyName} - ${statusDoc.documentType}</h2>
        <p style="color: #cbd5e1; font-size: 14px;">
          Hello <strong>${order.customerName || 'Valued Customer'}</strong>,<br/><br/>
          ${messageNote || statusDoc.emailAttachmentLabel}
        </p>

        <div style="background: #1e293b; padding: 16px; border-radius: 8px; margin: 20px 0; border-left: 4px solid #0284c7;">
          <div style="font-size: 13px; color: #94a3b8;">Invoice Number: <strong style="color: #ffffff;">${invNum}</strong></div>
          <div style="font-size: 13px; color: #94a3b8; margin-top: 4px;">Order ID: <strong style="color: #ffffff;">#${rawId}</strong></div>
          <div style="font-size: 13px; color: #94a3b8; margin-top: 4px;">Date: <strong style="color: #ffffff;">${order.date || new Date().toLocaleDateString()}</strong></div>
          <div style="font-size: 16px; color: #38bdf8; font-weight: bold; margin-top: 8px;">${statusDoc.amountLabel}: ${currency}${total.toFixed(2)}</div>
        </div>

        ${order.secureToken ? `<div style="margin-top: 24px;"><a href="https://rheditography.net/invoice/${order.secureToken}" style="display: inline-block; padding: 12px 24px; background: #0ea5e9; color: #fff; text-decoration: none; border-radius: 8px; font-weight: bold;">View & Pay Invoice</a></div>` : ''}
        <p style="font-size: 12px; color: #64748b;">
          Thank you for choosing RH Editography! For questions, reply to support@rheditography.net
        </p>
      </div>
    `;

    const sendResult = await sendEmailNotification({
      to: targetEmail,
      subject: `${statusDoc.emailSubjectPrefix} #${invNum} - RH Editography`,
      type: 'INVOICE',
      html: invoiceHtml,
      orderData: order
    });

    return {
      success: sendResult.success,
      message: sendResult.success
        ? `Invoice successfully sent to ${targetEmail}!`
        : `Failed to send email: ${sendResult.message}`
    };
  } catch (fallbackErr: any) {
    return {
      success: false,
      message: fallbackErr?.message || 'Failed to dispatch invoice PDF email.'
    };
  }
}
